import React, { useEffect, useRef, useState } from 'react';
import { useOverlay } from '../contexts/OverlayContext';
import { Close } from '@mui/icons-material';
import OverlayEquipFooter from './OverlayEquipFooter';
import './Overlay.css';

// Same breakpoint as the mobile block in Overlay.css.
const MOBILE_MQ = '(max-width: 62.4375rem)';

const Overlay = () => {
    const { isOverlayOpen, overlayContent, overlayFooter, overlayOpts, hideOverlay } = useOverlay();
    const overlayRef = useRef(null);
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
    );

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_MQ);
        const onChange = (e) => setIsMobile(e.matches);
        setIsMobile(mq.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);

    // Close overlay on Escape key press
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                hideOverlay();
            }
        };

        if (isOverlayOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOverlayOpen, hideOverlay]);

    // Close overlay on click outside
    const handleBackdropClick = (event) => {
        if (overlayRef.current === event.target) {
            hideOverlay();
        }
    };

    if (!isOverlayOpen) {
        return null;
    }

    const children = React.Children.toArray(overlayContent);
    let header = null;
    let content = null;

    if (children.length === 1) {
        content = children[0];
    } else if (children.length > 1) {
        header = children[0];
        content = children.slice(1);
    }

    // Desktop keeps the equip action in reach: it rides in the top bar, left of close.
    const promoteEquipToHeader =
        !isMobile && React.isValidElement(overlayFooter) && overlayFooter.type === OverlayEquipFooter;
    const headerEquip = promoteEquipToHeader
        ? React.cloneElement(overlayFooter, { variant: 'header' })
        : null;

    return (
        <div className="overlay-backdrop" ref={overlayRef} onClick={handleBackdropClick}>
            <div
                className={`overlay-wrapper${overlayOpts?.compact ? ' overlay-wrapper--compact' : ''}`.trim()}
            >
                <div className="overlay-container panel no-padding">
                    <div className="overlay-header row">
                        {header}
                        {headerEquip}
                        <button className="overlay-close-button" onClick={hideOverlay}>
                            <Close />
                        </button>
                    </div>
                    <div className="overlay-content">{content}</div>
                    {overlayFooter && !promoteEquipToHeader ? (
                        <div className="overlay-footer">
                            {overlayFooter}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Overlay;
